import { SET_PROVIDER, CLEAR_PROVIDER } from '../actions/types';

const initialState = null;
let newState;

function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_PROVIDER:
      newState = action.payload ? { ...action.payload } : undefined;
      return newState;
    case CLEAR_PROVIDER: {
      return null;
    }

    default:
      return state;
  }
}
export default reducer;
